import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import { AnalyticsWebClientProvider } from '@dev-agents/analytics';
import { useAuthData } from '@dev-agents/auth-context';
import { ErrorBoundary } from '@dev-agents/error-boundary';
import {
	TenantContextProvider,
	type TenantContextProviderQuery as tenantContextProviderQuery,
} from '@dev-agents/tenant-context';
import { type PreloadedQuery } from 'react-relay';

import { App } from './App';

export const AppWithTenantContext = ({
	tenantQueryRef,
}: {
	tenantQueryRef: PreloadedQuery<tenantContextProviderQuery> | null | undefined;
}) => {
	const authData = useAuthData();

	return (
		<ErrorBoundary componentName="AppWithTenantContext">
			<Placeholder name="dev-agents-tenant-context">
				{tenantQueryRef ? (
					<TenantContextProvider queryRef={tenantQueryRef}>
						<AnalyticsWebClientProvider authData={authData}>
							<App />
						</AnalyticsWebClientProvider>
					</TenantContextProvider>
				) : (
					<UFOLoadHold name="dev-agents-auth-context" />
				)}
			</Placeholder>
		</ErrorBoundary>
	);
};
